import { Box } from "@mui/material";
import React, { Fragment } from "react";
import classess from "./Style.module.css";

const Nums = ({ FOOTER, B, B1, B2 }) => {
  const nominativArray = Object.values(FOOTER.Examples);

  return (
    <Fragment>
      <span className={classess.TitleSubTitle}>{FOOTER.Title}</span>
      <Box className={classess.Footers}>
        {nominativArray.map((opt, index) => (
          <Fragment key={index}>
            <span
              style={{
                backgroundColor:
                  index === B[0] || index === B[1]
                    ? B1
                    : index === B[2] || index === B[3]
                    ? B2
                    : null,
              }}
            >
              {FOOTER.Type}
              {FOOTER.Type.length === 0 ? null : <label>:</label>} „{" "}
              <label className={classess.Label}>{opt[0]}</label>“{" → "}
              <label className={classess.nom}>{opt[1]}</label>
            </span>
          </Fragment>
        ))}
      </Box>
    </Fragment>
  );
};

export default Nums;
